<script lang="ts">
  import Footer from "../footer/Footer.svelte";
  import Navbar from "../header/Navbar.svelte";
  import { _ } from "svelte-i18n";
</script>

<svelte:head>
  <title>ANYWAYS | {$_("newsletter.pagetitle")}</title>
</svelte:head>

<Navbar isFluid={false} />

<section class="pt-8 pt-md-11 pb-8 pb-md-14">
  <div class="container">
    <div class="row justify-content-center pb-4">
      <div class="col-12 col-md-10 col-lg-8 text-center">
        <h2 class="font-weight-bold">
          {$_("newsletter.title")}
        </h2>
        <p class="font-size-lg text-muted">
          {$_("newsletter.description")}
        </p>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-6 col-lg-6">
        <form
          action="https://anyways.us14.list-manage.com/subscribe/post"
          method="POST">
          <input type="hidden" name="u" value="f1fd1c0efb76d15b4df9d90a7" />
          <input type="hidden" name="id" value="2fc9864079" />

          <div class="row justify-content-center">
              <!-- people should not fill these in and expect good things -->
              <div
                class="field-shift d-none"
                aria-label="Please leave the following three fields empty"
                aria-hidden="true">
                <label for="b_name">Name: </label>
                <input
                  type="text"
                  name="b_name"
                  tabindex="-1"
                  value=""
                  placeholder="Freddie"
                  id="b_name" />

                <label for="b_email">Email: </label>
                <input
                  type="email"
                  name="b_email"
                  tabindex="-1"
                  value=""
                  placeholder="youremail@gmail.com"
                  id="b_email" />

                <label for="b_comment">Comment: </label>
                <textarea
                  name="b_comment"
                  tabindex="-1"
                  placeholder="Please comment"
                  id="b_comment" />
              </div>

            <div class="col-12 col-md-7">
              <div class="form-group">
                <input
                type="email"
                autocapitalize="none"
                autocorrect="off"
                name="MERGE0"
                id="MERGE0"
                size="25"
                value="" 
                class="form-control required email"
                  placeholder="hello@domain.com" />
              </div>
            </div>


            <div class="col-auto">
              <div class="submit_container clear">
                <input
                  type="submit"
                  name="Submit"
                  value={$_("newsletter.submit")}
                  class="btn btn-primary lift" />
              </div>
            </div>
          </div>
          <input
            type="hidden"
            name="ht"
            value="b0848d8730024fd220a2367be82d95630109cbe7:MTY4MzA5OTEwMi4zMTg4" />
          <input type="hidden" name="mc_signupsource" value="hosted" />
        </form>
      </div>
      <div class="row justify-content-center pt-8">
        <div class="col-12 col-md-10 col-lg-8 text-center">
          <p class="font-size-lg text-muted mb-7 mb-md-9" />
        </div>
      </div>
    </div>
  </div>
</section>

<div class="position-relative">
  <div class="shape shape-bottom shape-fluid-x text-dark">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg"
      ><path
        d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
        fill="currentColor" /></svg>
  </div>
</div>

<Footer bgClass="bg-dark" />
